import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      
      {/* TOP SECTION */}
      <div className="footer-content">

        <div className="footer-col">
          <h3>Hello Car</h3>
          <p>Your trusted automotive partner.</p>
          <NavLink to="/about">About Us</NavLink><br/>
          <NavLink to="/booking">Book An Appointment</NavLink>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/products">Products</NavLink></li>
            {/* <li><NavLink to="/blog">Blogs</NavLink></li> */}
            <li><NavLink to="/contacts">Contact</NavLink></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact Us</h4>
          <p>Email: hellocar.rohit@gmail.com</p>
          <p>Phone: +91 98992 08565</p>
        </div>

      </div>

      {/* COPYRIGHT LINE */}
      <div className="footer-bottom">
        © 2025 Hello Car. All rights reserved.
      </div>
    </footer>
  );
}
